import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; 
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { 
    Box, Button, Container, Table, Pagination, TableBody, TableCell, 
    TableHead, TableRow, TextField, Card, Typography, IconButton,
    Stack, Chip, TableContainer, CircularProgress, InputAdornment 
} from "@mui/material";
import { Search as SearchIcon, EditOutlined, VisibilityOutlined, HistoryOutlined, EventOutlined } from "@mui/icons-material";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { useEffect, useState, useRef } from "react";
import { GetNameChoose } from "../../funcUtils";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

// ==========================================
// HÀM RENDER XÚC XẮC VÀ ĐỒNG XU
// ==========================================
const renderSmallDice = (numStr, key) => {
    const num = Number(numStr);
    if (isNaN(num) || num < 1 || num > 6) return null;
    const dot = <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#fff', boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)' }} />;
    const faces = {
        1: <Box display="flex" justifyContent="center" alignItems="center" height="100%">{dot}</Box>,
        2: <Box display="flex" justifyContent="space-between" p={0.6} height="100%"><Box alignSelf="flex-start">{dot}</Box><Box alignSelf="flex-end">{dot}</Box></Box>,
        3: <Box display="flex" justifyContent="space-between" p={0.6} height="100%"><Box alignSelf="flex-start">{dot}</Box><Box alignSelf="center">{dot}</Box><Box alignSelf="flex-end">{dot}</Box></Box>,
        4: <Box display="flex" justifyContent="space-between" p={0.6} height="100%"><Stack justifyContent="space-between">{dot}{dot}</Stack><Stack justifyContent="space-between">{dot}{dot}</Stack></Box>,
        5: <Box display="flex" justifyContent="space-between" p={0.6} height="100%"><Stack justifyContent="space-between">{dot}{dot}</Stack><Box alignSelf="center">{dot}</Box><Stack justifyContent="space-between">{dot}{dot}</Stack></Box>,
        6: <Box display="flex" justifyContent="space-between" p={0.6} height="100%"><Stack justifyContent="space-between">{dot}{dot}{dot}</Stack><Stack justifyContent="space-between">{dot}{dot}{dot}</Stack></Box>,
    };
    return (
        <Box key={key} sx={{ 
            width: 32, height: 32, backgroundColor: '#EF4444', borderRadius: '6px', 
            boxShadow: 'inset 0 -3px 0 rgba(0,0,0,0.25), inset 0 2px 0 rgba(255,255,255,0.2), 0 3px 5px rgba(239, 68, 68, 0.4)',
            border: '1px solid #B91C1C'
        }}>
            {faces[num]}
        </Box>
    );
};

const renderSmallCoin = (valStr, key) => {
    const val = Number(valStr);
    return (
        <Box key={key} sx={{ 
            width: 20, height: 20, borderRadius: '50%',
            background: val === 1 
                ? 'radial-gradient(circle at 35% 35%, #ff4b4b 0%, #d92b54 60%, #a31028 100%)' 
                : 'radial-gradient(circle at 35% 35%, #ffffff 0%, #f8f9fa 50%, #e2e6ea 100%)',
            boxShadow: val === 1 
                ? 'inset -2px -2px 5px rgba(0,0,0,0.3), inset 2px 2px 5px rgba(255,255,255,0.4), 0 3px 6px rgba(0,0,0,0.2)' 
                : 'inset -2px -2px 5px rgba(0,0,0,0.1), inset 2px 2px 5px rgba(255,255,255,1), 0 3px 6px rgba(0,0,0,0.15)',
            border: val === 1 ? '1px solid #b31b37' : '1px solid #d1d5db',
        }} />
    );
};

// ĐÃ THÊM: Hàm cắt bỏ tiền tố sảnh (VD: "2_0014" -> "0014")
const formatId = (idData) => {
    if (!idData) return "---";
    const rawId = typeof idData === 'object' ? idData.id_bet : idData;
    const strId = String(rawId);
    return strId.includes('_') ? strId.split('_').pop() : strId;
};

function HistoryBetAll() {
    const [data, setData] = useState(null);
    const [searched, setSearched] = useState("");
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(new Date());
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [total, setTotal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 12;
    const typingTimeoutRef = useRef(null);

    const openPopup = (item) => { setTotal(item); setIsOpen(true); };
    const closePopup = () => setIsOpen(false);

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${d.getUTCFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)}  ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const fetchHistory = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}/history/all?date=${endDate}&page=${page}&limit=${limit}&search=${searched}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) setTotalPages(res.data.totalPages);
                setLoading(false);
            })
            .catch(() => { setData(null); setLoading(false); });
    };

    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, endDate, searched]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => { setSearched(value); setPage(1); }, 500);
    };

    const handleChangePage = (e, newPage) => setPage(newPage);

    const [st, setSt] = useState(0);
    const handleChangeStatus = (e) => {
        if (ls?.status_bet === "Lose" || ls?.status_bet === "Pending") {
            if (e.target.value === "Win") setSt(1);
        } else {
            if (e.target.value === "Lose" || e.target.value === "Pending") setSt(2);
        }
        setLs((prev) => ({ ...prev, status_bet: e.target.value }));
    };

    const handleSubmitLs = (e) => {
        e.preventDefault();
        const formData = {
            id: ls?._id, userId: ls?.user?._id, status_bet: e.target.status_bet.value,
            state: e.target.state.value, money: e.target.money.value,
            moneyuser: st == 1 ? e.target.moneythang.value : st == 2 ? Number(ls?.moneythang) * -1 : 0,
            moneythang: e.target.moneythang.value
        };
        axios.patch(`${process.env.REACT_APP_API_URL}/history`, formData)
            .then(() => { setShow(false); swal(t('success'), "", "success").then(() => fetchHistory()); })
            .catch(() => { setShow(false); swal(t('error'), "", "error"); });
    };

    // ==========================================
    // 🟢 HÀM MỚI CHUYÊN TRỊ HIỂN THỊ CHO BACCARAT
    // ==========================================
    const getBaccaratBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { 
            "1": "CON", "2": "CÁI", "3": "HÒA", "4": "SUPER 6", 
            "5": "CON ĐÔI", "6": "CÁI ĐÔI", "7": "ĐÔI BẤT KỲ", "8": "ĐÔI HOÀN MỸ", 
            "9": "TÀI", "10": "XỈU", "11": "CON LẺ", "12": "CON CHẴN", 
            "13": "CÁI LẺ", "14": "CÁI CHẴN", "17": "CON LONG BẢO", "18": "CÁI LONG BẢO"
        };
        return String(stateStr).split(" ").map(s => map[s] || s).join(", ");
    };

    const renderBaccaratResult = (resultStr) => {
        try {
            const rs = JSON.parse(resultStr);
            return (
                <Box display="flex" alignItems="center" gap={1} sx={{ backgroundColor: '#F9FAFB', px: 1.5, py: 0.5, borderRadius: '6px', border: '1px solid #EFF2F5' }}>
                    <Typography variant="body2" fontWeight="900" color="#1B84FF">Con: {rs.playerScore ?? '?'}</Typography>
                    <Typography variant="caption" fontWeight="800" color="#A1A5B7">-</Typography>
                    <Typography variant="body2" fontWeight="900" color="#F1416C">Cái: {rs.bankerScore ?? '?'}</Typography>
                </Box>
            );
        } catch(e) {
            return <Typography variant="caption" fontWeight="700" color="text.secondary">Lỗi hiển thị</Typography>;
        }
    };
    // ==========================================

    const tableHeadSx = {
        color: "#A1A5B7 !important", fontWeight: "800 !important", fontSize: "0.75rem !important", 
        backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important",
        textTransform: "uppercase !important", whiteSpace: "nowrap"
    };

    const inputStyle = {
        width: "100%", height: "46px", padding: "0 14px", border: "1px solid #E4E6EF", 
        borderRadius: "8px", outline: "none", fontSize: "0.9rem", fontWeight: "600",
        fontFamily: "'Plus Jakarta Sans', sans-serif", color: "#181C32", 
        backgroundColor: "#F9F9F9", transition: "border-color 0.2s ease"
    };

    const renderStatus = (status) => {
        if (status === "Win") return <Chip label={t("win")} size="small" sx={{ backgroundColor: '#DCFCE7', color: '#16A34A', fontWeight: 800, borderRadius: '6px' }} />;
        if (status === "Lose") return <Chip label={t("lose")} size="small" sx={{ backgroundColor: '#FFF5F8', color: '#F1416C', fontWeight: 800, borderRadius: '6px' }} />;
        if (status === "Pending") return <Chip label={t("pending")} size="small" sx={{ backgroundColor: '#FFF8DD', color: '#FFC700', fontWeight: 800, borderRadius: '6px' }} />;
        return <Chip label={t("canceled")} size="small" sx={{ backgroundColor: '#F5F8FA', color: '#7E8299', fontWeight: 800, borderRadius: '6px' }} />;
    }

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>

                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-history-zone * { text-align: left; box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; }
                        .custom-input-metronic:focus { border-color: #1B84FF !important; background-color: #FFFFFF !important; box-shadow: 0 0 0 3px rgba(27, 132, 255, 0.1); }

                        /* =================================================== */
                        /* ĐẠI TU TOÀN BỘ CSS DATE PICKER ĐỂ GIỐNG HỆT ẢNH MẪU */
                        /* =================================================== */

                        /* 1. Vỏ bọc Input ngày */
                        .custom-date-wrapper input {
                            border: none !important; 
                            background: transparent; 
                            outline: none; 
                            font-weight: 800; 
                            color: #1B84FF; 
                            width: 100px; 
                            cursor: pointer;
                            font-family: 'Plus Jakarta Sans', sans-serif !important;
                            font-size: 0.95rem;
                            padding: 4px 8px;
                            border-radius: 6px;
                            text-align: center !important;
                            transition: box-shadow 0.2s;
                        }

                        /* 2. Đẩy z-index và xóa tam giác mặc định */
                        .react-datepicker-popper {
                            z-index: 9999 !important;
                        }
                        .react-datepicker__triangle {
                            display: none !important;
                        }

                        /* 3. Khung bảng lịch chính */
                        .react-datepicker {
                            font-family: 'Plus Jakarta Sans', sans-serif !important;
                            border: none !important;
                            border-radius: 12px !important;
                            box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1) !important;
                            padding: 15px 15px !important;
                            background-color: #fff !important;
                            margin-top: 10px;
                        }

                        /* 4. Header (Tháng/Năm) */
                        .react-datepicker__header {
                            background-color: #FFFFFF !important;
                            border-bottom: none !important;
                            padding: 0 0 10px 0 !important;
                        }
                        .react-datepicker__current-month {
                            color: #181C32 !important;
                            font-weight: 800 !important;
                            font-size: 1.25rem !important;
                            text-align: left !important;
                            padding-left: 28px;
                            margin-bottom: 15px !important;
                        }

                        /* 5. Tên Thứ (Su, Mo, Tu...) */
                        .react-datepicker__day-names {
                            border-bottom: 1px dashed #EFF2F5;
                            padding-bottom: 8px;
                            margin-bottom: 5px;
                        }
                        .react-datepicker__day-name {
                            color: #A1A5B7 !important;
                            font-weight: 700 !important;
                            width: 2.2rem !important;
                            font-size: 0.85rem !important;
                        }

                        /* 6. Các số Ngày */
                        .react-datepicker__day {
                            color: #3F4254 !important;
                            font-weight: 700 !important;
                            width: 2.2rem !important;
                            height: 2.2rem !important;
                            display: inline-flex !important;
                            align-items: center !important;
                            justify-content: center !important;
                            border-radius: 8px !important;
                            margin: 0.15rem !important;
                            transition: all 0.2s;
                        }
                        .react-datepicker__day:hover {
                            background-color: #F1FAFF !important;
                            color: #1B84FF !important;
                        }

                        /* 7. Ngày đang được chọn */
                        .react-datepicker__day--selected, .react-datepicker__day--keyboard-selected {
                            background-color: #1B84FF !important;
                            color: #FFFFFF !important;
                            font-weight: 800 !important;
                            box-shadow: 0px 4px 12px rgba(27, 132, 255, 0.4) !important;
                            border-radius: 8px !important;
                            border: none !important;
                        }

                        /* 8. Mũi tên chuyển tháng */
                        .react-datepicker__navigation {
                            top: 14px !important;
                        }
                        .react-datepicker__navigation--previous {
                            left: 14px !important;
                        }
                        .react-datepicker__navigation-icon::before {
                            border-color: #1B84FF !important;
                            border-width: 2.5px 2.5px 0 0 !important;
                            width: 9px !important;
                            height: 9px !important;
                            top: 6px !important;
                            transition: border-color 0.2s;
                        }
                        .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
                            border-color: #0d6efd !important;
                        }
                    `}</style>

                    <Box className="safe-history-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>

                        {isLoading && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">

                            {/* HEADER & TÌM KIẾM THEO GIAO DIỆN MỚI */}
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <HistoryOutlined fontSize="large" color="primary" />
                                    <Box>
                                        <Typography variant="h5" fontWeight="800" color="#181C32">Lịch sử chơi</Typography>
                                        <Typography variant="body2" color="text.secondary">Quản lý và tra cứu toàn bộ lịch sử cược của người dùng</Typography>
                                    </Box>
                                </Box>

                                <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap alignItems="center">
                                    <TextField 
                                        onChange={handleSearchChange} 
                                        placeholder="search..." 
                                        size="small"
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: '#A1A5B7', fontSize: '1.2rem' }} /></InputAdornment>,
                                            sx: { borderRadius: '6px', backgroundColor: '#FFFFFF', '& fieldset': { borderColor: '#E4E6EF' }, minWidth: '220px', fontSize: '0.85rem', height: '38px', fontWeight: '500' }
                                        }}
                                    />

                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, backgroundColor: '#FFFFFF', p: '0 8px', borderRadius: '6px', border: '1px solid #E4E6EF', height: '38px' }}>
                                        <Typography variant="caption" fontWeight="600" color="text.secondary" sx={{ ml: 1 }}>NGÀY:</Typography>
                                        <Box className="custom-date-wrapper">
                                            <DatePicker
                                                maxDate={new Date()}
                                                selected={endDate}
                                                dateFormat="MM/dd/yyyy"
                                                onChange={(date) => {
                                                    setEndDate(date);
                                                    setPage(1);
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                </Stack>
                            </Box>

                            {/* BẢNG DỮ LIỆU */}
                            <Card sx={{ backgroundColor: '#FFFFFF', borderRadius: '8px' }}>
                                <TableContainer sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1600 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>PHIÊN</TableCell>
                                                <TableCell sx={tableHeadSx}>TÊN ĐĂNG NHẬP</TableCell>
                                                <TableCell sx={tableHeadSx}>SỐ DƯ HIỆN TẠI</TableCell>
                                                <TableCell sx={tableHeadSx}>GAME</TableCell>
                                                <TableCell sx={tableHeadSx}>BET</TableCell>
                                                <TableCell sx={tableHeadSx}>KẾT QUẢ</TableCell>
                                                <TableCell sx={tableHeadSx}>TIỀN CƯỢC</TableCell>
                                                <TableCell sx={tableHeadSx}>TIỀN THẮNG</TableCell>
                                                <TableCell sx={tableHeadSx}>TRẠNG THÁI</TableCell>
                                                <TableCell sx={tableHeadSx}>THỜI GIAN</TableCell>
                                                {profile?.permission?.set == 1 ? <TableCell align="right" sx={{...tableHeadSx, pr: 3}}></TableCell> : null}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {data && data.length > 0 ? (
                                                data.map((item) => (
                                                    <TableRow key={item._id} hover sx={{ verticalAlign: 'middle' }}>
                                                        <TableCell sx={{ pl: 3 }}>
                                                            <Typography variant="body2" fontWeight="800" color="#181C32">
                                                                {/* ĐÃ THAY ĐỔI: Áp dụng formatId để ẩn tiền tố 1_, 2_ */}
                                                                #{formatId(item?.id_bet)}
                                                            </Typography>
                                                        </TableCell>

                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="800" color="#1B84FF">
                                                                {item?.user?.username}
                                                            </Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: "700" }}>
                                                            {Math.floor(item?.user?.money || 0).toLocaleString("vi-VN")} đ
                                                        </TableCell>

                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="700" color="#1B84FF">
                                                                {/* ĐÃ THAY ĐỔI: Lấy game_name để hiện rõ Baccarat (Bàn X) */}
                                                                {item?.game_name || item?.sanh}
                                                            </Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: "800", color: "#181C32", maxWidth: "200px", whiteSpace: "normal" }}>
                                                            {item?.sanh === "Baccarat" 
                                                                ? getBaccaratBetLabel(item?.state) 
                                                                : GetNameChoose(item?.state, item?.type, item?.sanh)}
                                                        </TableCell>

                                                        <TableCell>
                                                            {item?.id_bet && (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>

                                                                    {item?.sanh === "Greedy" && (
                                                                        <img alt="" src={require(`../game/Greedy/images/food_${item?.id_bet?.result}.png`)} style={{ height: "25px" }} />
                                                                    )}

                                                                    {item?.sanh?.indexOf("Xóc đĩa") !== -1 && (
                                                                        <Box sx={{ display: "flex", gap: '4px' }}>
                                                                            {String(item?.id_bet?.result).replace(/\s/g, '').split("").map((x, i) => renderSmallCoin(x, i))}
                                                                        </Box>
                                                                    )}

                                                                    {item?.sanh?.indexOf("Tài xỉu") !== -1 && (
                                                                        <Box sx={{ display: "flex", gap: '4px' }}>
                                                                            {String(item?.id_bet?.result).replace(/\s/g, '').split("").map((x, i) => renderSmallDice(x, i))}
                                                                        </Box>
                                                                    )}

                                                                    {(item?.sanh?.indexOf("Xổ số") !== -1 || item?.sanh === "XSMB" || item?.sanh === "XSMT" || item?.sanh === "XSMN") && (
                                                                        item?.id_bet?.dacbiet && (
                                                                            <Button 
                                                                                variant="outlined" size="small" 
                                                                                onClick={() => openPopup(item?.id_bet)}
                                                                                sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '4px', py: 0.2, fontSize: '0.75rem', borderColor: '#E4E6EF', color: '#1B84FF' }}
                                                                                startIcon={<VisibilityOutlined fontSize="small" />}
                                                                            >
                                                                                Xem KQ
                                                                            </Button>
                                                                        )
                                                                    )}

                                                                    {item?.sanh === "CatDog" && (
                                                                        <Typography variant="body2" fontWeight="800" color="#1B84FF">
                                                                            {GetNameChoose(item?.id_bet?.result?.slice(-1), null, "CatDog").replace("Chọn ", "")}
                                                                        </Typography>
                                                                    )}

                                                                    {/* KẾT QUẢ DÀNH RIÊNG CHO BACCARAT */}
                                                                    {item?.sanh === "Baccarat" && (
                                                                        <Box>
                                                                            {item?.id_bet?.result ? renderBaccaratResult(item.id_bet.result) : (
                                                                                <Typography variant="caption" fontWeight="700" color="text.secondary" sx={{ fontStyle: 'italic', backgroundColor: '#F5F8FA', px: 1.5, py: 0.5, borderRadius: '6px', border: '1px dashed #E4E6EF' }}>
                                                                                    {item?.status_bet === "Pending" ? "Đang chờ mở bài..." : "Đã trả thưởng"}
                                                                                </Typography>
                                                                            )}
                                                                        </Box>
                                                                    )}

                                                                </Box>
                                                            )}
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: "800", color: "#181C32" }}>
                                                            {item?.money.toLocaleString("vi-VN")} đ
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: "800", color: item?.moneythang > 0 ? "#50CD89" : "#A1A5B7" }}>
                                                            {item?.moneythang > 0 ? "+" : ""}{item?.moneythang.toLocaleString("vi-VN")} đ
                                                        </TableCell>

                                                        <TableCell>
                                                            {renderStatus(item?.status_bet)}
                                                        </TableCell>

                                                        <TableCell sx={{ color: "text.secondary", fontSize: "0.8rem", fontWeight: "500" }}>
                                                            {formatDate(new Date(item?.createdAt))}
                                                        </TableCell>

                                                        {profile?.permission?.set == 1 && (
                                                            <TableCell align="right" sx={{ pr: 3 }}>
                                                                <IconButton 
                                                                    size="small" 
                                                                    onClick={() => {
                                                                        setLs(item);
                                                                        setSt(item?.status_bet === "Win" ? 1 : item?.status_bet === "Lose" ? 2 : 0);
                                                                        setShow(true);
                                                                    }}
                                                                    sx={{ color: '#A1A5B7', '&:hover': { color: '#1B84FF', backgroundColor: '#F1FAFF' } }}
                                                                >
                                                                    <EditOutlined fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={11} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 700 }}>
                                                        {t("empty")}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", borderTop: '1px solid #EFF2F5' }}>
                                    {data != null ? <Pagination color="primary" shape="rounded" page={page} count={totalPages} size="small" onChange={handleChangePage} sx={{ '& .MuiPaginationItem-root': { fontWeight: 700 } }} /> : null}
                                </Box>
                            </Card>
                        </Container>
                    </Box>

                    {/* MODAL SỬA KẾT QUẢ CƯỢC */}
                    {isShow && (
                        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(3px)' }}>
                            <Card sx={{ width: '450px', p: 3 }}>
                                <Typography variant="h6" fontWeight="800" mb={1} color="#181C32">
                                    Sửa Đơn Cược
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={3}>
                                    Tài khoản: <Typography component="span" fontWeight="800" color="#1B84FF">{ls?.user?.username}</Typography>
                                </Typography>

                                <form onSubmit={handleSubmitLs}>
                                    <Stack spacing={2.5}>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" p={1.5} sx={{ backgroundColor: '#F9F9F9', borderRadius: '8px', border: '1px solid #EFF2F5' }}>
                                            <Typography variant="body2" fontWeight="700">Trò Chơi</Typography>
                                            {/* ĐÃ THAY ĐỔI */}
                                            <Chip label={ls?.game_name || ls?.sanh} size="small" sx={{ backgroundColor: '#F1FAFF', color: '#1B84FF', fontWeight: 800 }} />
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("bet")} (Cửa đặt)</Typography>
                                            <input className="custom-input-metronic" name="state" defaultValue={ls?.state} style={inputStyle} type="text" />
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("money_bet")} (Tiền Cược)</Typography>
                                            <input className="custom-input-metronic" name="money" defaultValue={ls?.money} style={inputStyle} type="number" />
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("money_win")} (Tiền Thắng)</Typography>
                                            <input className="custom-input-metronic" name="moneythang" defaultValue={ls?.moneythang} style={inputStyle} type="number" />
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" fontWeight="800" color="text.secondary" sx={{ mb: 0.5, display: 'block', textTransform: 'uppercase' }}>{t("status")} (Kết quả)</Typography>
                                            <select 
                                                name="status_bet" value={ls?.status_bet} onChange={handleChangeStatus}
                                                className="custom-input-metronic" style={{ ...inputStyle, cursor: 'pointer' }}
                                            >
                                                <option value="Win" style={{ color: "#16A34A", fontWeight: 'bold' }}>{t("win")} (Thắng)</option>
                                                <option value="Lose" style={{ color: "#F1416C", fontWeight: 'bold' }}>{t("lose")} (Thua)</option>
                                                <option value="Pending" style={{ color: "#FFC700", fontWeight: 'bold' }}>{t("pending")} (Chờ KQ)</option>
                                                <option value="Cancelled" style={{ color: "#7E8299", fontWeight: 'bold' }}>{t("canceled")} (Hủy)</option>
                                            </select>
                                        </Box>
                                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
                                            <Button variant="outlined" color="inherit" onClick={() => setShow(false)} sx={{ fontWeight: 800, px: 3, borderRadius: '8px' }}>{t("close")}</Button>
                                            <Button variant="contained" color="primary" type="submit" sx={{ fontWeight: 800, px: 4, borderRadius: '8px', boxShadow: 'none' }}>{t("submit")}</Button>
                                        </Stack>
                                    </Stack>
                                </form>
                            </Card>
                        </Box>
                    )}

                    {/* MODAL XEM CHI TIẾT KẾT QUẢ XỔ SỐ */}
                    {isOpen && total && (
                        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(3px)' }}>
                            <Card sx={{ width: '500px', p: 0, overflow: 'hidden' }}>
                                <Box sx={{ p: 2.5, backgroundColor: '#1B84FF', color: '#FFF', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="h6" fontWeight="800">Kết Quả {t("session")} #{formatId(total?.id_bet)}</Typography>
                                </Box>
                                <Box sx={{ p: 3, maxHeight: '60vh', overflowY: 'auto' }}>
                                    <Stack spacing={1.5}>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#F1416C' }}>ĐB</Typography>
                                            <Typography variant="h6" fontWeight="900" color="#F1416C" sx={{ flex: 1, textAlign: 'center', letterSpacing: '2px' }}>{total?.dacbiet}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 1</Typography>
                                            <Typography variant="body1" fontWeight="800" color="#181C32" sx={{ flex: 1, textAlign: 'center', letterSpacing: '2px' }}>{total?.nhat}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 2</Typography>
                                            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                                                {total?.hai?.split(" ").map((v, i) => <Typography key={i} variant="body2" fontWeight="800">{v}</Typography>)}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 3</Typography>
                                            <Box sx={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, textAlign: 'center' }}>
                                                {total?.ba?.split(" ").map((v, i) => <Typography key={i} variant="body2" fontWeight="800">{v}</Typography>)}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 4</Typography>
                                            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                                                {total?.tu?.split(" ").map((v, i) => <Typography key={i} variant="body2" fontWeight="800">{v}</Typography>)}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 5</Typography>
                                            <Box sx={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, textAlign: 'center' }}>
                                                {total?.nam?.split(" ").map((v, i) => <Typography key={i} variant="body2" fontWeight="800">{v}</Typography>)}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', borderBottom: '1px dashed #EFF2F5', pb: 1.5 }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 6</Typography>
                                            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                                                {total?.sau?.split(" ").map((v, i) => <Typography key={i} variant="body2" fontWeight="800">{v}</Typography>)}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <Typography variant="body2" fontWeight="800" sx={{ width: '70px', color: '#181C32' }}>Giải 7</Typography>
                                            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
                                                {total?.bay?.split(" ").map((v, i) => <Typography key={i} variant="body2" fontWeight="800" color="#F1416C">{v}</Typography>)}
                                            </Box>
                                        </Box>
                                    </Stack>
                                </Box>
                                <Box sx={{ p: 2, borderTop: '1px solid #EFF2F5', backgroundColor: '#F9F9F9', textAlign: 'right' }}>
                                    <Button variant="contained" color="error" onClick={closePopup} sx={{ fontWeight: 800, borderRadius: '8px', boxShadow: 'none', px: 4 }}>Đóng</Button>
                                </Box>
                            </Card>
                        </Box>
                    )}

                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default HistoryBetAll;